import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';

export function isGestorSuart(codigoPerfil?: number | null): boolean {
  return codigoPerfil === Perfil.SuartAure || codigoPerfil === Perfil.SuartAtsuArt;
}
